export default __webpack_public_path__ + "static/media/16.01fb9204.jpg";